

import { UserCog, MessageCircle, Users, DatabaseZap, ScrollText, Settings } from 'lucide-react';
import { QuickAction } from '../../quick-actions';
import { ProfileModalActions } from '@/src/stores/general';

export const accountSettings: QuickAction[] = [
    {
        icon: <UserCog className="w-4 h-4" />,
        text: "Users Management",
        description: "Add or edit users and permissions to your account.",
        href: "/dashboard/users",
        newTabHref: "/dashboard/users"
    },
    {
        icon: <MessageCircle className="w-4 h-4" />,
        text: "Knowledge Base",
        description: "Access guides, API docs, and integration tutorials.",
        href: "/knowledge",
        newTabHref: "/knowledge"
    },
    {
        icon: <Users className="w-4 h-4" />,
        text: "Invite team member",
        description: "Add new users to Clickster and assign them to a workspace",
        disabled: true,
        badge: "Coming Soon",
        newTabHref: "/users/invite"
    },
    {
        icon: <Settings className="w-4 h-4" />,
        text: "Account Settings",
        description: "Manage your account preferences and billing information.",
        onClick: () => ProfileModalActions.open(),
    },
    {
        icon: <DatabaseZap className="w-4 h-4" />,
        text: "Postbacks and Pixels",
        description: "View available pixels to share with affiliate networks to fire back events to clickster.",
        href: "/dashboard/pixels",
        newTabHref: "/dashboard/pixels"
    },
    {
        icon: <ScrollText className="w-4 h-4" />,
        text: "Cost & Conversion Logs",
        description: "Review logs for all processes like Cost Update, Conversion Update and more.",
        href: "/dashboard/process-logs",
        newTabHref: "/dashboard/process-logs"
    }
]; 